import React from "react";

interface SNAlbumMessageProps {
  albumsDetails: any;
  data: any;
  type?: "facebook" | "instagram";
}

function SNAlbumMessage({
  albumsDetails,
  data,
  type = "facebook",
}: SNAlbumMessageProps): JSX.Element {
  let t = window.INITIAL_DATA.TRANSLATIONS;

  return (
    <>
      {albumsDetails === null && data === null ? (
        <p className={"text-center m-0 p-4"}>
          {type == "facebook"
            ? t.facebook_authenticate_first
            : t.instagram_authenticate_first}
        </p>
      ) : albumsDetails === null ? (
        <p className={"text-center m-0 p-4"}>
          {type == "facebook"
            ? t.facebook_could_not_load_albums
            : t.instagram_could_not_load_photos}
          <br></br>
          {`${t.please_try_again}`}
        </p>
      ) : albumsDetails.length === 0 ? (
        <p className={"text-center m-0 p-4"}>
          {type == "facebook"
            ? t.facebook_no_photos_uploaded
            : t.instagram_no_photos_uploaded}
          <br></br>
          {`${t.no_photos_uploaded}`}
        </p>
      ) : null}
    </>
  );
}

export default SNAlbumMessage;
